export const customWorkflowsList = {
  push: [
    {
      title: "Getting Started",
      description:
        "Guide users through the essential steps to set up and begin using the app",
      type: "getting-started",
    },
  ],
  pull: [
    {
      title: "Getting Started",
      description:
        "Guide users through the essential steps to set up and begin using the app",
      type: "getting-started",
    },
    {
      title: "Coach Daily Monitoring",
      description:
        "Send clients a daily Morning Brief summarizing what they need to do today",
      type: "coach-daily-monitoring",
    },
  ],
};

export const WORKFLOW_NAME_MAP = {
  "getting-started": "Getting Started",
  "coach-daily-monitoring": "Coach Daily Monitoring",
};
